<div class="row">
  <!--Top section-->
  <div class="col-md-12 row-no-margin">
    <h3 *ngIf="IsCreate">Create New Quote</h3>
    <h3 *ngIf="!IsCreate">Edit Quote</h3>

  </div>
  <div class="col-md-12 row-no-margin">
    
    <!--Column 1-->
    <div class="col-md-3">
      <div class="row-no-margin col-md-12 clear-padding">
        
        <mat-form-field appearance="fill" style="width:50%;">
          <mat-label>Customer:</mat-label>
          <mat-select id="custSelect" (selectionChange)="Customer_Change($event)" [disabled]="!IsCreate" [value]="SelectedCustomer.CompanyId">
            @for(cust of Customers;track cust){
            <mat-option [value]="cust.CompanyId">
              {{cust.Company}}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" floatLabel="always" style="width:200px;">
          <mat-label>Quote #:</mat-label>
          <input matInput class="mat-focused" placeholder="Quote #" readonly="readonly" [(ngModel)]="CurrentQuote.QuoteNumber" />
        </mat-form-field>
        <!--<mat-form-field appearance="fill">
          <mat-label>Ship To:</mat-label>
          <mat-select id="shipToSelect" (selectionChange)="ShipTo_Change($event)" [(value)]="SelectedShipTo">
            @for(shipTo of ShipToCustomers;track shipTo;){
            <mat-option [value]="shipTo">
              {{shipTo.Company}}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>-->
      </div>
      <!--Ship To Address section-->
      <div class="row-no-margin col-md-10">
        <mat-form-field appearance="fill" floatLabel="always" style="width:200px;">
          <mat-label>Project:</mat-label>
          <input matInput class="mat-focused" placeholder="Project" [(ngModel)]="CurrentQuote.ProjectName" />
        </mat-form-field>
        <mat-form-field appearance="fill" floatLabel="always">
          <mat-label>Description:</mat-label>
          <input matInput class="mat-focused" placeholder="Description" [(ngModel)]="CurrentQuote.Description" />
        </mat-form-field>

        <!--<input #cAd name="CA" placeholder="Address" autocomplete="off" class="smallInput smallMargin" style="width:80%;" [(ngModel)]="SelectedCustomer.Address1" />
  <br />
  <input #cC name="CC" placeholder="City" autocomplete="off" class="smallInput  smallMargin"  [(ngModel)]="SelectedCustomer.City" />
  <input #cS name="CS" placeholder="State" autocomplete="off" class="smallInput smallMargin" style="width:100px;" [(ngModel)]="SelectedCustomer.State" />
  <input #cZ name="CZ" placeholder="Zip" autocomplete="off" class="smallInput smallMargin" style="width:100px;" [(ngModel)]="SelectedCustomer.ZipCode" />
  <input #cCu name="CCU" placeholder="Country" autocomplete="off" class="smallInput smallMargin"style="width:150px;" [(ngModel)]="SelectedCustomer.Country" />-->

      </div>
    </div>
    <!--Column 2-->
    <div class="col-md-1" style="width:10% !important;">
      <div class="row-no-margin col-md-12 clear-padding">
        <mat-form-field>
          <mat-label>Effective Date</mat-label>
          <input matInput [matDatepicker]="effectiveDatePicker" [value]="CurrentQuote.EffectiveDate" (change)="SetEffectiveDate($event)">
          <mat-hint>MM/DD/YYYY</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="effectiveDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #effectiveDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="row-no-margin col-md-12 clear-padding">
        <mat-form-field>
          <mat-label>Expiration Date</mat-label>
          <input matInput [matDatepicker]="expirationDatePicker" [value]="CurrentQuote.ExpirationDate" (change)="SetExpirationDate($event)">
          <mat-hint>MM/DD/YYYY</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="expirationDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #expirationDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <div class="col-md-2">
      <div class="row-no-margin col-md-12">
        <mat-form-field appearance="fill" >
          <mat-label>Territory:</mat-label>
          <mat-select id="territorySelect" (selectionChange)="Territory_Change($event)" [value]="CurrentQuote.TerritoryCode">
            @for(t of Territories;track t){
            <mat-option [value]="t.TerritoryCode">
              {{t.TerritoryName}}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="row-no-margin col-md-12">
        <mat-form-field appearance="fill" >
          <mat-label>RSM:</mat-label>
          <mat-select id="rsmSelect"  [(value)]="CurrentQuote.Salesman">
            @for(r of RSMs;track r){
            <mat-option [value]="r.SlsPersonID">
              {{r.Name}}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="row-no-margin col-md-12">
        <mat-form-field appearance="fill" floatLabel="always" >
          <mat-label>AE:</mat-label>
          <input matInput class="mat-focused" placeholder="AE:"  [(ngModel)]="CurrentQuote.AE" />
        </mat-form-field>
        <!--<mat-form-field appearance="fill" >
    <mat-label>AE:</mat-label>
    <mat-select id="aeSelect" (selectionChange)="AE_Change($event)" [value]="SelectedAE">
      @for(a of AEs;track a){
      <mat-option [value]="a">
        {{a}}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>-->
      </div>
    </div>
    <div class="col-md-2" style="text-align:right;">     
      <button class="blue clickable smallMargin smallButton" style="width:60%;" (click)="AddConfiguredLine()">Add Configured Line</button>
      <br />
      <button class="blue clickable smallMargin smallButton" style="width:60%;" (click)="AddSP()">Add SP</button>
      <br />
      <button class="blue clickable smallMargin smallButton" style="width:60%;" (click)="Add8Digit()">Add 8 Digit</button>
      <br />
      <button class="blue clickable smallMargin smallButton" style="width:60%;" (click)="AddFee()">Add Fee</button>
    </div>
    <div class="col-md-3" style="text-align:right;padding-right:5%;">
      <button class="blue clickable smallMargin smallButton" style="width:50%;" (click)="SaveQuote()">Save</button>
      <br />
      <button class="blue clickable smallMargin smallButton" style="width:50%;" (click)="DownloadQuote()">Download</button>
      <br />
      <button class="blue clickable smallMargin smallButton" style="width:50%;" (click)="RepriceAllLines()">Reprice All Lines</button>

    </div>
  </div>
  <!--Line items-->
  <div [hidden]="CurrentQuote.QuoteDetails.length == 0" class="col-md-12 detail-container" style="margin-bottom:20px;">
    <h4>Lines</h4>
    <br />
    @for(detail of CurrentQuote.QuoteDetails;track detail;){
    <app-quote-detail [CurrentDetail]="detail" [IsDirectCustomer]="IsDirectCustomer" (DeleteLineEmitter)="RemoveLine(detail)" (ReconfigureEmitter)="ReconfigureDetail(detail)" SaveLineEmitter="SaveQuote()">

    </app-quote-detail>
    
    }
  </div>
  <!--Fees-->
  <div [hidden]="CurrentQuote.QuoteFees != null && CurrentQuote.QuoteFees.length == 0" class="col-md-12 detail-container" style="margin-bottom:20px;">
    <div>
      <h4>Fees</h4>
    </div>
    <div>
      <!--Fee grid-->
      <table class="detailTable" style="width:80%;">
        <tr class="detailTableHeader">
          <th style="text-align:center;">
            Fee
          </th>
          <th style="text-align:center;">
            Description
          </th>
          <th style="text-align:center;">
            QTY
          </th>
          <th style="text-align:center;">
            Total Cost
          </th>
          <th style="text-align:center;">
            Edit
          </th>
          <th style="text-align:center;">
            Remove
          </th>
        </tr>
        @for(f of CurrentQuote.QuoteFees;track f){
        <tr>
          <td style="text-align:center;">
            {{f.FeeName}}
          </td>
          <td style="text-align:center;">
            {{f.Description}}
          </td>
          <td style="text-align:center;">
            {{f.Qty}}
          </td>
          <td style="text-align:center;">
            {{(f.Qty * f.UnitPrice) | currency}}
          </td>
          <td style="text-align:center;">
            <fa-icon [icon]="faEdit" (click)="EditFee(f)" class="fa-light fa-2x  clickable blue-color"></fa-icon>
          </td>
          <td style="text-align:center;">
            <fa-icon [icon]="faX" (click)="DeleteFee(f)" class="fa-light fa-2x  clickable blue-color"></fa-icon>
          </td>
        </tr>
        }

      </table>
    </div>
  </div>
</div>
<div #spinnerModal id="spinnerModal" [hidden]="hideLoadingModal" style="width:100%;height:inherit;float:left;position:absolute;z-index:10000;display:block;left:0;top:0px;bottom:0px; background-color:#AAAAAA;opacity:0.4;">
  <div style="position: absolute; top: 45%; left: 45%;">
    <mat-spinner mode="indeterminate"></mat-spinner>
  </div>
</div>
